export default __webpack_public_path__ + "static/media/consuelo_bn.d93354a6.jpg";